import { Box, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import { Button } from "../../../components";
import { SingleSelectInput } from "../../../components/SelectInput";
import DateInput from "../../../components/UserInput/DateInput";
import { colors } from "../../../theme/colors";
import type { HealthOrgOption, SpecimenTrackingFilters } from "../utils";

type Props = {
  filters: SpecimenTrackingFilters;
  onChange: (filters: SpecimenTrackingFilters) => void;
  healthOrgOptions: HealthOrgOption[];
  onExport: () => void;
  exportDisabled?: boolean;
};

const HeaderBar = ({
  filters,
  onChange,
  healthOrgOptions,
  onExport,
  exportDisabled,
}: Props) => {
  const orgData = healthOrgOptions.map((org) => ({
    id: org.id,
    label: org.name,
    value: org.id,
  }));

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "16px",
          mt: 1
        }}
      >
        <Box sx={{ width: 350 }}>
          <SingleSelectInput
            placeholder="Select health organisation"
            name="healthOrg"
            data={orgData}
            value={filters.healthOrgId ?? ""}
            onChange={(e) =>
              onChange({
                ...filters,
                healthOrgId: e.target.value
                  ? Number(e.target.value)
                  : undefined,
              })
            }
            onClear={() => onChange({ ...filters, healthOrgId: undefined })}
          />
        </Box>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box >
            <DateInput
              label="From"
              value={filters.from ? dayjs(filters.from) : null}
              onChange={(date) =>
                onChange({
                  ...filters,
                  from: date ? date.toISOString() : filters.from,
                })
              }
              maxDate={filters.to ? dayjs(filters.to) : undefined}
              clearable={false}
            />
          </Box>
          <Box >
            <DateInput
              label="To"
              value={filters.to ? dayjs(filters.to) : null}
              onChange={(date) =>
                onChange({
                  ...filters,
                  to: date ? date.toISOString() : filters.to,
                })
              }
              minDate={filters.from ? dayjs(filters.from) : undefined}
              clearable={false}
            />
          </Box>
        </LocalizationProvider>

        <Box sx={{ flexGrow: 1 }} />

        <Box >
          <Button
            variant="contained"
            label="Export CSV"
            onClick={onExport}
            disabled={exportDisabled}
            sx={{ borderRadius: "8px", height: 48, px: 3, whiteSpace: "nowrap" }}
          />
        </Box>
      </Box>

      <Typography
        variant="caption"
        sx={{ color: colors.grey, display: "block", mt: 1.5 }}
      >
        Default view shows the last 24 hours of specimen tracking activity.
      </Typography>
    </Box>
  );
};

export default HeaderBar;
